<!-- 代理商管理 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<!-- 标题 -->
		<div class="page-title" style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">代理商管理</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">账户名称</div>
				<a-input v-model="r_company" allowClear placeholder="请输入" style="width: 240px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">状态</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择状态"
					@change="handleChangeA"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">启用</a-select-option>
					<a-select-option value="0">禁用</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="addButton" type="primary">+ 新增</a-button>
		</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;" 
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<!-- ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 账户名称 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.company}}
					</div>
				</div>
				
				<!-- 秘钥 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.secret}}
				</div>
				
				<!-- Status -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					<!-- {{item.status == 1?'是':'否'}} -->
					<a-switch @change="statusChange($event,item)" :checked="item.status_checked" :loading="item.status_loading" size="small" checked-children="启用" un-checked-children="关闭" />
				</div>
				<!-- 创建时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					{{item.created_at}}
				</div>
				
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	</div>
	
	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;"> -->
		<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;position: sticky;left: 30px;z-index: 5;">
			<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange"  />
		</div>
	<!-- </div> -->
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="900px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">账户名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_company" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box" style="height: 40px;">
				<div class="class-title">是否启用</div>
					
				<a-switch :checked="x_status" @change="switchChangeB" checked-children="启用" un-checked-children="关闭" />
			</div>
			
			<div class="form-cell-box" style="align-items: baseline;">
				<div class="class-title" style="flex-shrink: 0;">公众号权限</div>
				
				<div style="width: 700px;">
					<div v-for="(item,index) in gzhGroup" :key="index" style="margin-bottom: 25px;">
						<a-checkbox :indeterminate="item.indeterminate_all" :checked="item.checked_all" @change="onCheckAllChange($event,item,index)">
							{{item.name}}
						</a-checkbox>
						<div v-show="!item.child_show && item.child.length > 0" @click="childShow(item)" style="display: inline-block;color: #62a8ea;cursor: pointer;margin-left: 10px;">展开</div>
						<div v-show="item.child_show && item.child.length > 0" @click="childShow(item)" style="display: inline-block;color: #62a8ea;cursor: pointer;margin-left: 10px;">收起</div>
						<div v-show="item.child_show && item.child.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 20px;margin-top: 10px;">
							<div v-for="(item_z,index_z) in item.child" :key="index_z" style="margin-bottom: 5px;margin-right: 10px;">
								<a-checkbox  :checked="item_z.checked_z" @change="onCheckChange($event,index,index_z)">
									{{item_z.name}}
								</a-checkbox>
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { agentAdmList, agentAdmAdd, agentAdmEdit, agentAdmChangeStatus, agentAdmGzhList } from '@/request/api'
export default {
	name: 'agentAdmin_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:100, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"账户名称", width:200, type:"name", },
				{title:"秘钥", width:220, type:"corp_id", },
				{title:"状态", width:150, type:"secret", },
				{title:"创建时间", width:200, type:"token", },
				{title:"操作", width:100, type:"cz", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			
			search_button_loading: false,
			r_search:"",
			r_page: 1,
			table_total: 0,
			r_status: undefined, // 状态
			r_company: "", // 账户/公司名称
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增/编辑参数
			x_id: '', // id
			x_company: "", // 名称
			x_status: true, // 是否启用，true为启用
			
			gzhGroup: [],
		}
	},
	mounted(){
		let that = this
		
		that.body_width = document.body.clientWidth - 100 // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		// 代理商公众号列表
		agentAdmGzhList().then(res=>{
			console.log("代理商公众号列表",res);
			// 对数据进行处理
			let data = res.data.data.list
			
			data.forEach(res=>{
				res.checked_all = false
				res.indeterminate_all = false
				res.child_show = true
				if(res.child){
					res.child.forEach(res_z=>{
						res_z.checked_z = false
					})
				}
				else {
					res.child = []
				}
				
			})
			
			that.gzhGroup = data
		})
		
		
		that.searchButton()
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		handleChangeA(e){
			console.log(e);
			this.r_status = e
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			agentAdmList({
				page: that.r_page,
				status: that.r_status,
				company: that.r_company
			}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					data.forEach((res,index)=>{
						res.status_checked = false
						res.status_loading = false // 变更状态的加载中状态
						if(res.status == 1){ // 1=开启 0=关闭
							res.status_checked = true
						}
					})
					that.tableShowData = data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log("item",item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			that.x_company = item.company // 名称
			
			if(item.status == 1){
				that.x_status = true
			}
			else {
				that.x_status = false
			}
			let k_data = item.content
			that.gzhGroup.forEach(res=>{
				if(res.child.length > 0){ // 得有下级内容才能进行下一步，不然状态会乱
					let ttt = true
					res.child.forEach(res_z=>{
						k_data.forEach(res_k=>{
							if(res_z.id == res_k){
								res_z.checked_z = true
							}
						})
						if(!res_z.checked_z){ // 有一个没选中说明就没有全选了
							ttt = false
						}
					})
					
					if(ttt){
						res.checked_all = true // 全选
					}
				}
				
			})
			
			that.visible = true
		},
		// 查看权限
		showPermissions(){
			let that = this
			
		},
		// 侧边栏的新增/编辑
		addRequest(){
			let that = this
			console.log("contentTableData",that.contentTableData);
			if(!that.x_company){ // 账户名称
				// that.add_form_hint = "请填写 账户名称 ！！！"
				that.$message.warning('请填写 账户名称 ！！！');
			}
			
			
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let g_data = []
				that.gzhGroup.forEach(res=>{
					res.child.forEach(res_z=>{
						if(res_z.checked_z){
							g_data.push(res_z.id)
						}
					})
				})
				console.log("g_data",g_data);
				
				let r_data = {
					id: that.x_id,
					company: that.x_company,
					content: g_data // 代理商授权公众号数组id
				}
				if(that.x_status){
					r_data.status = 1 // 表示开启
				}
				else {
					r_data.status = 0 // 表示关闭
				}
				
				if(that.drawer_title === "新增"){
					agentAdmAdd(r_data).then(res=>{
						console.log("新增",res)
						that.add_button_loading = false
						
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('新增成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "新增失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("新增失败，可能是网络出现问题");
					})
				}
				else if(that.drawer_title === "编辑"){
					agentAdmEdit(r_data).then(res=>{
						console.log("编辑",res)
						that.add_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('编辑成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("编辑失败，可能是网络出现问题");
					})
				}
				
			}
			
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			this.x_id = ""
			this.x_company = "" // 名称
			
			this.x_status = true // 是否启用，true为启用
			
			this.gzhGroup.forEach(res=>{
				res.checked_all = false
				res.child.forEach(res_z=>{
					res_z.checked_z = false
				})
			})
			
			this.add_form_hint = ""
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
		
		// 状态切换
		statusChange(e,item){
			let that = this
			console.log("状态切换",e,item);
			item.status_loading = true
			agentAdmChangeStatus({
				id: item.id
			}).then(res=>{
				console.log("状态切换",res);
				item.status_loading = false
				
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					item.status_checked = e
					if(e){ // 这里的状态也要更新。1=开启 0=关闭
						item.status = 1
					}
					else {
						item.status = 0
					}
					that.$message.success('操作成功');
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		
		// 是否启用
		switchChangeB(e){
			console.log(e);
			this.x_status = e
		},
		
		
		
		
		// 全选/取消全选
		onCheckAllChange(e,item,index){
			let that = this
			if(that.gzhGroup[index].checked_all){
				that.gzhGroup[index].child.forEach(res=>{
					res.checked_z = false
				})
				that.gzhGroup[index].checked_all = false
				// that.gzhGroup[index].indeterminate_all = false
			}
			else {
				that.gzhGroup[index].child.forEach(res=>{
					res.checked_z = true
				})
				that.gzhGroup[index].checked_all = true
				// that.gzhGroup[index].indeterminate_all = true
			}
		},
		// 单选
		onCheckChange(e,index,index_z){
			let that = this
			console.log(that.gzhGroup[index].child[index_z].id)
			that.gzhGroup[index].child[index_z].checked_z = !that.gzhGroup[index].child[index_z].checked_z
			
			let ttt = true // 用于判断是否全选
			that.gzhGroup[index].child.forEach(res=>{
				if(!res.checked_z){
					ttt = false
				}
			})
			if(ttt){
				that.gzhGroup[index].checked_all = true // 全选
			}
			else {
				that.gzhGroup[index].checked_all = false // 取消全选
			}
		},
		// 展开/收起控制
		childShow(item){
			console.log(item);
			item.child_show = !item.child_show
		}
	}
}
</script>

<style scoped>
.form-cell-box {
	margin-bottom: 20px;
}

</style>